import "./WhoWeAre.css";
import "./theme.css";
import { useEffect } from "react";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import DiamondOutlinedIcon from "@mui/icons-material/DiamondOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";

export default function WhoWeAre() {
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme") || "light";
    document.documentElement.setAttribute("data-theme", savedTheme);
  }, []);

  const highlights = [
    {
      number: "01",
      icon: <SecurityOutlinedIcon />,
      label: "Digital-first safety",
    },
    {
      number: "02",
      icon: <AnalyticsOutlinedIcon />,
      label: "Operational intelligence",
    },
    {
      number: "03",
      icon: <GroupsOutlinedIcon />,
      label: "Continuous improvement",
    },
  ];

  const cards = [
    {
      number: "01",
      icon: <VisibilityOutlinedIcon />,
      title: "Our Vision",
      text: "To redefine industrial safety by creating intelligent, interconnected systems that enable zero incidents across all workplaces.",
    },
    {
      number: "02",
      icon: <FlagOutlinedIcon />,
      title: "Our Mission",
      text: "To empower organizations with data-driven safety platforms that ensure compliance, prevent incidents, and drive continuous improvement.",
    },
    {
      number: "03",
      icon: <DiamondOutlinedIcon />,
      title: "Core Values",
      text: "Innovation, integrity, and impact guide every solution we build — ensuring reliability, scalability, and real-world value for our clients.",
    },
  ];

  return (
    <main className="who-page">
      <section className="who-hero">
        {/* photo bleeds to the right edge of the page */}
        <div className="who-photo-wrap" aria-hidden="true">
          <div className="who-photo-glow" />
          <div
            className="who-photo"
            style={{ backgroundImage: "url(/AboutUs.jpg)" }}
          >
            <div className="who-photo-overlay" />
          </div>
          <div className="who-photo-chip">SAFETY · TECHNOLOGY · IMPACT</div>
        </div>

        <div className="who-hero-shell">
          <div className="who-copy">
            <div className="who-eyebrow">ABOUT PARIVIKSHAK</div>

            <h1>
              Who We <span>Are</span>
            </h1>

            <h2 className="who-subtitle">
              Transforming Industrial Safety through Intelligent Technology.
            </h2>

            <p>
              We are a technology-first organization focused on transforming
              industrial safety through intelligent digital systems. Our
              platform bridges the gap between regulatory compliance and
              operational efficiency — enabling organizations to embed safety
              into everyday workflows rather than treating it as a checklist.
            </p>

            <p>
              By combining automation, analytics, and intuitive design, we help
              industries reduce risk, improve accountability, and build a
              culture where safety becomes a strategic advantage.
            </p>

            <div className="who-highlights">
              {highlights.map((h) => (
                <div className="who-highlight" key={h.number}>
                  <div className="who-highlight-icon">{h.icon}</div>
                  <div>
                    <strong>{h.number}</strong>
                    <span>{h.label}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="who-panel">
            {cards.map((card) => (
              <article className="who-panel-item" key={card.number}>
                <div className="who-panel-icon">{card.icon}</div>
                <div className="who-panel-head">
                  <span>{card.number}</span>
                  <h3>{card.title}</h3>
                </div>
                <p>{card.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
